export const FILTER_ALERT_COMPONENT_TRANSLATION_NAMESPACE = "filter-alert-components";

export const OFFER_FILTER_ALERT_TK = "OFFER_FILTER_ALERT_TK";
export const SPONSORED_AD_FILTER_ALERT_TK = "SPONSORED_AD_FILTER_ALERT_TK";
export const MARKETING_ACTION_FILTER_ALERT_TK = "MARKETING_ACTION_FILTER_ALERT_TK";
